import { render, staticRenderFns } from "./RadioButtons.vue?vue&type=template&id=7985150c&"
import script from "./RadioButtons.vue?vue&type=script&lang=js&"
export * from "./RadioButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports